import { render } from "./Buttons.vue?vue&type=template&id=fb24039e"
import script from "./Buttons.vue?vue&type=script&lang=ts"
export * from "./Buttons.vue?vue&type=script&lang=ts"

import "./Buttons.vue?vue&type=style&index=0&id=fb24039e&lang=stylus"
script.render = render

export default script